import classnames from 'classnames';
import styles from './TextTruncate.module.sass';

type TextTruncateProps = {
  text: string;
  lines?: number;
  maxChars?: number;
  className?: string;
  title?: string;
};

export const TextTruncate = ({ text, lines = 1, maxChars, className, title }: TextTruncateProps) => {
  const truncateStyles = {
    WebkitLineClamp: lines,
  };

  const displayText =
    typeof maxChars === 'number' && maxChars > 0 && text.length > maxChars
      ? `${text.slice(0, Math.max(0, maxChars - 3)).trimEnd()}...`
      : text;

  return (
    <div className={classnames(styles.textTruncate, className)} style={truncateStyles} title={title ?? text}>
      {displayText}
    </div>
  );
};
